import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import {useTranslation} from "react-i18next";

const PageTitle = ({ title }) => {
  const location = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    document.title = title;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location, t(title)]);

  return null; // This component doesn't render anything
};

export default PageTitle;
